import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { TFMService } from 'app/mock-api/tfm.service';
import { NgClass, NgStyle } from '@angular/common';
import { RouterLink } from '@angular/router';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatDialog } from '@angular/material/dialog';
import { BannerSectionType01Component } from '../../banner-section/banner_section-type01/banner_section-type01.component';

@Component({
  selector: 'app-about-type05',
  standalone: true,
  imports: [MatIconModule, NgClass, RouterLink, MatTooltipModule, BannerSectionType01Component],
  templateUrl: './about-type05.component.html',
  styleUrl: './about-type05.component.scss'
})
export class AboutType05Component implements OnInit {

  public view: any = {
    title: '',
    bannerLoaded: false,
    bannerError: false,
  }


  constructor(public _tfmService: TFMService, private _cd: ChangeDetectorRef, public dialog: MatDialog) {
  }

  startSlideshow(): void {
    setInterval(() => {
      const nextIndex = (this.view.currentImageIndex + 1) % this.view.imageHrefs.length;
      const nextImage = this.view.imageHrefs[nextIndex];

      this.fadeToImage(nextImage);
      this.view.currentImageIndex = nextIndex;
    }, 5000);
  }

  onBannerLoad(): void {
    this.view.bannerLoaded = true;
    this._cd.detectChanges();
  }

  onBannerError(): void {
    this.view.bannerError = true;
    this._cd.detectChanges();
  }

  fadeToImage(nextImage: string): void {
    const img = new Image();
    img.src = nextImage;

    img.onload = () => {
      if (this.view.activeLayer === 1) {
        this.view.imageLayer2 = nextImage;
        this.view.activeLayer = 2;
      } else {
        this.view.imageLayer1 = nextImage;
        this.view.activeLayer = 1;
      }
      this._cd.detectChanges();
    };
  }

  ngOnInit(): void {
    this._tfmService.getSite().then(res => {
      this.view.site = res;

      this.view.site.profile = this._tfmService.getSiteProfile(this.view.site.profileID);
      this._tfmService.log("About Site View:", this.view);
    });

    this.view.currentImageIndex = 0;
    this.view.activeLayer = 1;
    this.view.imageLayer1 = ''; // start blank or with a default image
    this.view.imageLayer2 = '';

    this._tfmService.getContentBySection('about').then((res) => {
      this.view.page = res;

      const images = this.view.page?.content?.images;

      if (images && images.length > 0) {
        this.view.imageHrefs = images
          .map((img: any) => {
            const viewLink = img._links?.find((link: any) => link.rel === 'view');
            return viewLink?.href ?? null;
          })
          .filter((href: string | null) => href !== null);

        this.view.imageLayer1 = this.view.imageHrefs[0];
        this.view.bannerLoaded = false;
        this.view.bannerError = false;
        this.startSlideshow();
      }
    });
  }
}

